import mainLogo from '../../images/BelcarMitsubishi/LOGO_ASUKA_main_white.png';
import squareLogo from '../../images/BelcarMitsubishi/Asuka_logo_square_small_red.png';
import squareLogoColor from '../../images/BelcarMitsubishi/logo_asuka_square_color.png';
import mainLogoWhite from '../../images/BelcarMitsubishi/logo_asuka_square_white.png';
import banner01 from '../../images/BelcarMitsubishi/banner_01.jpg';
import banner02 from '../../images/BelcarMitsubishi/banner_02.jpg';
import banner03 from '../../images/BelcarMitsubishi/banner_03.jpg';
import car123 from '../../images/BelcarMitsubishi/123_eclipseCross.jpg';
import box123 from '../../images/BelcarMitsubishi/123_belcarmitsubishi.jpg';
import { SliderProducts } from '../../Utilities/SliderProducts';

export const configData = {
    defaultStore: 'Asuka',
    defaultStoreLink: 'asukapecas.com.br',
    defaultContactEmail: 'supervisorvendasasuka@asuka.com.br',
    whatsappNumber: '62 99871 8302',
    CNPJ: '12.958.618/0001-48',
    CNPJname: 'Asuka Motors LTDA',
    CNPJaddress: 'Av. L, com rua 111, com rua 73, Quadra D5 Lote 18/34 - Jardim Goiás, Goiânia/GO - 74.810-105',
    launchDate: '30/04/2025',

    multiContact: {},

    searchByPlate: false,

    coupons: [
        // {
        //     coupon: '10PORCENTO',
        //     discountPrice: 0,
        //     discountPercent: 0.1,
        //     freeShipping: false,
        // },
        // {
        //     coupon: '10REAIS',
        //     discountPrice: 10,
        //     discountPercent: 0,
        //     freeShipping: false,
        // },
        // {
        //     coupon: 'FRETEGRATIS',
        //     discountPrice: 0,
        //     discountPercent: 0,
        //     freeShipping: true,
        // },
    ],

    brands: [
        "mitsubishi",
    ],

    homologBrands: [
        'motorcraft',
        'motrio',
        'acdelco',
        'mopar',
        'bproauto',
    ],

    noVehicle: false,

    storeSellersWarehouses: [
       "BELCAR ASUKA",
    ],

    disabledSellers: [],

    useMktNames: false,

    endYear: 2025,
    startYear: 1996,

    pixDiscount: 0.05,

    payment: {
        maxParcels: 6,
        checkoutParcels: {
            0: 1,
            200: 2,
            300: 3,
            600: 4,
            800: 5,
            1000: 6,
        }
    },

    customShipping: {
        deliveryTime: 1,
    },

    productSlider: [
        {
            name: 'Kits',
            img: 'tabKits',
            products: SliderProducts.Kits
        },
        {
            name: 'Óleos',
            img: 'tabOleos',
            products: SliderProducts.Oleos
        },
        {
            name: 'Filtros',
            img: 'tabFiltros',
            products: SliderProducts.Filtros
        },
        {
            name: 'Freios',
            img: 'tabFreios',
            products: SliderProducts.Freios
        },
        {
            name: 'Luzes',
            img: 'tabLuzes',
            products: SliderProducts.Luzes
        },
        {
            name: 'Acessórios',
            img: 'tabAcessorios',
            products: SliderProducts.Acessorios
        },
        // {
        //     name: 'Roupas',
        //     img: 'tabRoupas',
        //     products: SliderProducts.Roupas
        // },
    ]
}

export const contentData = {
    mainLogo: mainLogo,
    squareLogo: squareLogo,
    bannerLogoWhite: mainLogo,

    banner01: banner01,
    banner02: banner02,
    bannerBrands: '',
    aboutUsBg: banner03,


    car123: car123,
    box123: box123,
    
    paymentImg: squareLogoColor,
    paymentImgMobile: squareLogoColor,

    bannerHighlight: 'Compre peças <mark>novas e originais</mark>, compatíveis com seu Mitsubishi. Peças <mark>genuínas</mark> direto da concessionária <mark>Asuka</mark>.',

    aboutUs: {
        title: 'Nossa História',
        content: [
            'Inaugurada em dezembro de 2011, a Asuka se consolidou como referência no mercado de peças e acessórios originais para veículos 4x4 Mitsubishi em Goiânia. Com o respaldo da experiência e do empreendedorismo do Grupo Belcar, uma das empresas mais respeitadas de Goiás, a concessionária é conhecida por seu atendimento diferenciado, que tem conquistado a confiança e satisfação dos clientes ao longo de mais de 30 anos de atuação. Localizada em um ponto estratégico e de fácil acesso, às margens da BR 153, próximo ao Paço Municipal, a Asuka Motors ocupa uma ampla e moderna estrutura de 20.000 m², oferecendo um ambiente ideal para quem busca qualidade e confiança.',
            'A Asuka se destaca pela excelência no atendimento, com uma equipe de 80 profissionais treinados e comprometidos em oferecer um serviço de alto padrão, tanto na venda quanto no pós-venda, sempre com peças e acessórios 100% originais, diretamente da fábrica. A concessionária oferece ainda planos e condições especiais para facilitar a compra, garantindo aos seus clientes as melhores oportunidades de negócio. Para a Asuka, proporcionar uma experiência única de compra e garantir a satisfação total de seus clientes é mais do que um objetivo—é a sua verdadeira MISSÃO!',
        ],
        link: 'https://www.asuka.com.br/goiania-go/sobre-nos-concessionaria-mitsubishi',
        linkCta: 'Saiba mais',
    },

    socialMedia: {
        Instagram: 'https://www.instagram.com/asukamitsubishi/',
        Facebook: 'https://www.facebook.com/AsukaMitsubishi',
        LinkedIn: 'https://br.linkedin.com/company/asuka---mitsubishi-motors',
        Youtube: '',
        Twitter: '',
    },

    footerContent: [],
}